import React, { useState, useContext } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { AiFillCloseCircle } from "react-icons/ai";
import InputUI from "../material-ui/InputUI";
import ButtonUI from "../material-ui/ButtonUI";
import { AuthContext } from "../../context/Auth/AuthContext";
import addCategory from "../../api/addCategory";
import "../../styles/FieldSettings.css";
import addCategoryImg from "../../images/edit-category.png";

const addCategoryFormSchema = yup.object().shape({
  name: yup.string().required("Category Name is required field"),
  description: yup.string().required("Description is required field"),
  badge: yup.string().required("Badge name is required field"),
  bgColor: yup.string(),
});

const AddFieldSettings = ({
  onAddCategoryButtonClick,
  setCategoryAddedToTrue,
}) => {
  const [loading, setLoading] = useState(false);
  const [color, setColor] = useState("#d7cbef");
  const { token, userID } = useContext(AuthContext);
  const [showModal, setShowModal] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(addCategoryFormSchema),
  });

  const onAddCategoryFormSubmit = async (addCategoryFormData) => {
    setLoading(true);

    toast.info("Category is being added", {
      position: "top-center",
      autoClose: 3000,
      theme: "dark",
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

    const addCategoryFormResponse = await addCategory({
      token: token,
      user_id: userID,
      name: addCategoryFormData.name,
      description: addCategoryFormData.description,
      badge: addCategoryFormData.badge,
      bgColor: addCategoryFormData.bgColor,
    });

    if (addCategoryFormResponse?.code === 200) {
      setLoading(false);
      onAddCategoryButtonClick();
      setCategoryAddedToTrue();
      toast.success("Category is added successfully", {
        position: "top-center",
        autoClose: 3000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    if (addCategoryFormResponse?.code === 401) {
      setLoading(false);
      onAddCategoryButtonClick();
      setCategoryAddedToTrue();
      toast.success("Category already exist", {
        position: "top-center",
        autoClose: 3000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    if (
      addCategoryFormResponse?.errors?.name[0] ||
      addCategoryFormResponse?.errors?.description[0] ||
      addCategoryFormResponse?.errors?.createdBy[0]
    ) {
      setLoading(false);
      toast.error("Every field is required", {
        position: "bottom-right",
        autoClose: 5000,
        theme: "dark",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  const changeBgColor = (e) => {
    setColor(e.target.value);
  };
  const [tags, setTags] = useState([]);
  const [tagInput, setTagInput] = useState("");

  const handleAddTag = (e) => {
    if (e.key === "Enter" && tagInput.trim() !== "") {
      e.preventDefault();
      setTags([...tags, tagInput.trim()]);
      setTagInput("");
    }
  };

  const removeTag = (indexToRemove) => {
    setTags(tags.filter((_, index) => index !== indexToRemove));
  };
  const handleClose = () => {
    onAddCategoryButtonClick();
  };

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        {/* HEADER */}
        <div className="modal-header">
          <div className="modal-title">
            <span>Add New Category</span>
          </div>

          <AiFillCloseCircle
            className="modal-close"
            onClick={handleClose}
          />
        </div>

        {/* FORM */}
        <form
          className="modal-form"
          onSubmit={handleSubmit(onAddCategoryFormSubmit)}
        >
          <div className="top-fields">
            <div className="input-group">
              <InputUI
                name="name"
                label="Field Name"
                type="text"
                variant="outlined"
                register={register}
              />
            </div>

            <div className="input-group">
              <InputUI
                name="description"
                label="Description"
                type="text"
                variant="outlined"
                register={register}
              />
            </div>

            <div className="input-group">
              <InputUI
                name="badge"
                label="Field Type"
                type="text"
                variant="outlined"
                register={register}
              />
            </div>

            <div className="input-group">
              <InputUI
                name="status"
                label="Status"
                type="text"
                variant="outlined"
                register={register}
              />
            </div>
          </div>

          {/* TAG INPUT */}
          <div className="tags-container">
            {tags.map((tag, index) => (
              <div key={index} className="tag">
                {tag}
                <span onClick={() => removeTag(index)}>×</span>
              </div>
            ))}

            <input
              type="text"
              placeholder="Type keywords..."
              value={tagInput}
              onChange={(e) => setTagInput(e.target.value)}
              onKeyDown={handleAddTag}
            />
          </div>

          {/* SUBMIT */}
          <div className="modal-footer">
            <ButtonUI
              loading={loading}
              variant="contained"
              buttonText="Add Category"
              handleSubmit={handleSubmit}
              onFormSubmit={onAddCategoryFormSubmit}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFieldSettings;
